export enum TPIProviderCategoryEnum {
  SPORTS = 1,
  HORSES = 2,
  CASINO = 3,
  LIVE_DEALER = 4,
  PROPS_BUILDER = 5,
  CASINO_LIVE_DEALER = 6,
}
